module.exports = __webpack_public_path__ + "static/media/firebrand_vc.31fafc59.svg";